export const loadState = key => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (key, state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to save state', err);
  }
};

export const clearState = key => {
  try {
    localStorage.setItem(key, null);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to clear state', err);
  }
};

const ADS_PILOT_SETTINGS = 'ADS-PILOT-SETTINGS-CONFIG';

export const saveSettings = settings => saveState(ADS_PILOT_SETTINGS, settings);
export const loadSettings = () => loadState(ADS_PILOT_SETTINGS) || {};

export const isDisplayingArchivedProjects = (state = loadSettings()) =>
  state.displayArchivedProjects;
